import { FC } from 'react';

interface DividerProps {
  vertical?: boolean;
}

export const Divider: FC<DividerProps> = ({ vertical }) => {
  return <div className={`${vertical ? 'w-px' : 'h-px mt-4 mb-4'} bg-gray-300`} />;
};
